// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ProbationReviewsQueryVariables = Types.Exact<{
  pageNumber: Types.Scalars['Int']['input'];
  pageSize: Types.Scalars['Int']['input'];
  filter: Types.InputMaybe<Types.ListProbationReviewFilterInput>;
}>;

export type ProbationReviewsQuery = { __typename?: 'Query' } & {
  listProbationReviews: { __typename?: 'ListProbationReviews' } & Pick<Types.ListProbationReviews, 'totalCount'> & {
      items: Array<
        { __typename?: 'ProbationReview' } & Pick<
          Types.ProbationReview,
          | 'employeeId'
          | 'probationStatus'
          | 'outcome'
          | 'flags'
          | 'nextDueDate'
          | 'daysOverdue'
          | 'probationEndDate'
          | 'reviewerAbsent'
          | 'hasAuditLog'
        > & {
            currentReview: Types.Maybe<
              { __typename?: 'ProbationReviewPosition' } & Pick<Types.ProbationReviewPosition, 'index' | 'total'>
            >;
            displayedReview: Types.Maybe<
              { __typename?: 'ProbationReviewSummary' } & Pick<
                Types.ProbationReviewSummary,
                'dueDate' | 'reviewStatus' | 'reviewerId'
              > & {
                  reviewer: Types.Maybe<
                    { __typename?: 'Employee' } & {
                      generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
                        Types.EmployeeGeneralInformation,
                        'preferredFullName'
                      >;
                    }
                  >;
                }
            >;
            reviews: Array<
              { __typename?: 'ProbationReviewStage' } & Pick<Types.ProbationReviewStage, 'deadline' | 'reviewStatus'>
            >;
            employee: { __typename?: 'Employee' } & {
              generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
                Types.EmployeeGeneralInformation,
                'preferredFullName' | 'hiredDate'
              > & {
                  primaryManager: Types.Maybe<
                    { __typename?: 'Employee' } & Pick<Types.Employee, 'id'> & {
                        generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
                          Types.EmployeeGeneralInformation,
                          'preferredFullName'
                        >;
                      }
                  >;
                };
              currentMainContract: Types.Maybe<
                { __typename?: 'EmployeeContract' } & {
                  company: { __typename?: 'Company' } & Pick<Types.Company, 'name'>;
                }
              >;
              currentPosition: Types.Maybe<
                { __typename?: 'EmployeeJobHistory' } & Pick<Types.EmployeeJobHistory, 'level'> & {
                    location: { __typename?: 'Location' } & Pick<Types.Location, 'name'> & {
                        country: Types.Maybe<{ __typename?: 'Country' } & Pick<Types.Country, 'name'>>;
                      };
                    businessUnit: { __typename?: 'BusinessUnit' } & Pick<Types.BusinessUnit, 'name'>;
                  }
              >;
            };
          }
      >;
    };
};

export const ProbationReviewsDocument = /*#__PURE__*/ gql`
    query ProbationReviews($pageNumber: Int!, $pageSize: Int!, $filter: ListProbationReviewFilterInput) {
  listProbationReviews(
    pageNumber: $pageNumber
    pageSize: $pageSize
    filter: $filter
  ) {
    items {
      employeeId
      probationStatus
      outcome
      flags
      currentReview {
        index
        total
      }
      nextDueDate
      daysOverdue
      probationEndDate
      displayedReview {
        dueDate
        reviewStatus
        reviewerId
        reviewer {
          generalInformation {
            preferredFullName
          }
        }
      }
      reviewerAbsent
      hasAuditLog
      reviews {
        deadline
        reviewStatus
      }
      employee {
        generalInformation {
          preferredFullName
          hiredDate
          primaryManager {
            id
            generalInformation {
              preferredFullName
            }
          }
        }
        currentMainContract {
          company {
            name
          }
        }
        currentPosition {
          location {
            name
            country {
              name
            }
          }
          businessUnit {
            name
          }
          level
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useProbationReviewsQuery__
 *
 * To run a query within a React component, call `useProbationReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProbationReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProbationReviewsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProbationReviewsQuery(
  baseOptions: Apollo.QueryHookOptions<ProbationReviewsQuery, ProbationReviewsQueryVariables> &
    ({ variables: ProbationReviewsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProbationReviewsQuery, ProbationReviewsQueryVariables>(ProbationReviewsDocument, options);
}
export function useProbationReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProbationReviewsQuery, ProbationReviewsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProbationReviewsQuery, ProbationReviewsQueryVariables>(ProbationReviewsDocument, options);
}
// @ts-expect-error
export function useProbationReviewsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ProbationReviewsQuery, ProbationReviewsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ProbationReviewsQuery, ProbationReviewsQueryVariables>;
export function useProbationReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProbationReviewsQuery, ProbationReviewsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ProbationReviewsQuery | undefined, ProbationReviewsQueryVariables>;
export function useProbationReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProbationReviewsQuery, ProbationReviewsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProbationReviewsQuery, ProbationReviewsQueryVariables>(
    ProbationReviewsDocument,
    options,
  );
}
export type ProbationReviewsQueryHookResult = ReturnType<typeof useProbationReviewsQuery>;
export type ProbationReviewsLazyQueryHookResult = ReturnType<typeof useProbationReviewsLazyQuery>;
export type ProbationReviewsSuspenseQueryHookResult = ReturnType<typeof useProbationReviewsSuspenseQuery>;
